/** The action a CFO assessment leaves on a company (metadata
 *  `cfo_action`, written by the backend with each evaluation). What to
 *  do is on the company page, in the "Action required" panel. */
export const CFO_ACTIONS: Record<string, { label: string; hint: string }> = {
  review: {
    label: "Review needed",
    hint: "A founder place decides the outcome: choose its country on the company page.",
  },
  data: {
    label: "Data needed",
    hint: "A scoring input is missing: fill it on the company page.",
  },
};

/** Filter-picker labels for the `cfo_action` values. */
export const CFO_ACTION_LABELS: Record<string, string> = Object.fromEntries(
  Object.entries(CFO_ACTIONS).map(([value, action]) => [value, action.label]),
);
